__turbopack_context__.v({
  "caret": "FreshEdit-module__ok2MtW__caret",
  "disclosure": "FreshEdit-module__ok2MtW__disclosure",
  "disclosureButton": "FreshEdit-module__ok2MtW__disclosureButton",
  "info": "FreshEdit-module__ok2MtW__info",
  "input": "FreshEdit-module__ok2MtW__input",
  "inputWrapper": "FreshEdit-module__ok2MtW__inputWrapper",
  "item": "FreshEdit-module__ok2MtW__item",
  "notedit": "FreshEdit-module__ok2MtW__notedit",
  "title": "FreshEdit-module__ok2MtW__title",
  "titleLabel": "FreshEdit-module__ok2MtW__titleLabel",
  "widgets": "FreshEdit-module__ok2MtW__widgets",
});
